"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserById = void 0;
const getUserById = async (supabase, client_id) => {
    const { data: client, error: client_error } = await supabase
        .from("user_profiles")
        .select(`id,      
      first_name,
      last_name,
      email,
      display_currency,
      country_of_residence,
      nationality,
      settings,
      password_last_change_date,`)
        .eq("id", client_id)
        .single();
    if (client_error) {
        return null;
    }
    return client;
};
exports.getUserById = getUserById;
